import React from "react";
import Container from "../components/container";
import ChooseYourBra from "../components/SportsBra/chooseYourBra";
import PuttingOnYourBra from "../components/SportsBra/puttingOnYourBra";
import YourRecommendedBra from "../components/SportsBra/yourRecommendedBra";
import CheckBraSupport from "../components/SportsBra/checkBraSupport";
import { useWizardContextState } from "../context/wizardContext";
import WizardStep from "../components/SportsBra/WizardComponents/wizardStep";
import WizardContainer from "../components/SportsBra/WizardComponents/wizardContainer";
import styles from "./sportsBra.module.css";
import { processBraStats } from "../services/sportsBraProcessingService";

const SportsBra = () => {
  const wizardContext = useWizardContextState();

  const { cup, age, intensity, band, selectedCropTopSize, currentStep, braType } = wizardContext;

  React.useEffect(() => {
    sessionStorage.setItem("age", JSON.stringify(age));
    sessionStorage.setItem("band", JSON.stringify(band));
    sessionStorage.setItem("intensity", JSON.stringify(intensity));
    sessionStorage.setItem("cup", JSON.stringify(cup));
    sessionStorage.setItem("selectedCropTopSize", JSON.stringify(selectedCropTopSize));
    sessionStorage.setItem("currentStep", JSON.stringify(currentStep));
    sessionStorage.setItem("braType", JSON.stringify(braType));
  }, [cup, age, intensity, band, selectedCropTopSize, currentStep, braType]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  const HeaderNav = () => {
    return (
      <>
        <div className={styles.wizardStepsContainer}>
          <WizardStep step={0} stepToDisplay={"1"}>
            Sports bra design
          </WizardStep>
          <WizardStep step={2}>Sports bra fit</WizardStep>
          <WizardStep step={3}>Check sports bra support</WizardStep>
        </div>
      </>
    );
  };

  const FooterNav = () => {
    return (
      <>
        {currentStep === 0 && (
          <div className={styles.buttonGroup}>
            <button
              className={styles.actionButton}
              onClick={() => wizardContext.setCurrentStep(1)}
            >
              Find your bra
            </button>
          </div>
        )}
        {currentStep === 1 && (
          <div className={styles.buttonGroup}>
            <button
              className={styles.secondaryButton}
              onClick={() => wizardContext.setCurrentStep(0)}
            >
              Back
            </button>
            <button
              className={styles.actionButton}
              onClick={() => wizardContext.setCurrentStep(2)}
            >
              Fitting your bra cup
            </button>
          </div>
        )}
        {currentStep === 2 && (
          <div className={styles.buttonGroup}>
            <button
              className={styles.secondaryButton}
              onClick={() => wizardContext.setCurrentStep(1)}
            >
              Back
            </button>
            <button
              className={styles.actionButton}
              onClick={() => wizardContext.setCurrentStep(3)}
            >
              Check bra support
            </button>
          </div>
        )}
        {currentStep === 3 && (
          <div className={styles.buttonGroup}>
            <button
              className={styles.secondaryButton}
              onClick={() => wizardContext.setCurrentStep(2)}
            >
              Back
            </button>
            <button
              className={styles.actionButton}
              onClick={() => wizardContext.setCurrentStep(0)}
            >
              Check another bra
            </button>
          </div>
        )}
      </>
    );
  };

  const recommendation = processBraStats(cup, age, intensity, band, selectedCropTopSize, braType);

  return (
    <Container>
      <HeaderNav />
      <div>
        {currentStep === 0 && (
          <WizardContainer wizardHeading={"Find your sports bra design"}>
            <ChooseYourBra />
          </WizardContainer>
        )}

        {currentStep === 1 && (
          <WizardContainer wizardHeading={"We recommend you wear"}>
            <YourRecommendedBra breastSupportRecommended={recommendation} />
          </WizardContainer>
        )}

        {currentStep === 2 && (
          <WizardContainer
            wizardHeading={"How to check your sports bra fit"}
            wizardSubheading={
              "To check your bra fit, expand each section below and follow the steps in the videos or photos."
            }
          >
            <PuttingOnYourBra breastSupportRecommended={recommendation} />
          </WizardContainer>
        )}

        {currentStep === 3 && (
          <WizardContainer
            wizardHeading={"Is your bra supportive enough?"}
            wizardSubheading={
              <span>
                A supportive sports bra will reduce and slow down the movement
                of your breasts, so it is comfortable to exercise. Preventing
                your breasts “slapping” down against your torso while you are
                active is most important.{" "}
                <strong>
                  How much your breasts move and, in turn, the sports bra design you need
                  will vary during different activities.{" "}
                </strong> 
                No sports bra, however, should completely stop your breasts moving
                because to achieve absolutely no motion would require an
                extremely rigid and/or tight garment that is likely to be too
                uncomfortable to wear!
              </span>
            }
          >
            <CheckBraSupport breastSupportRecommended={recommendation} />
          </WizardContainer>
        )}
      </div>

      <FooterNav />
    </Container>
  );
};

export default SportsBra;
